/** The levels of a monthly limit (the most specific first). */
export const PARTNER_SPEND_LIMIT_LEVELS = ['COST_CENTER', 'MEMBERSHIP', 'ACCOUNT'];
export const PARTNER_BILLING_MODELS = ['BILLED', 'UNBILLED'];
export class PartnerCostControlAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    base(accountId) {
        return `/v1/admin/partner-accounts/${encodeURIComponent(accountId)}`;
    }
    view(accountId) {
        return this.client.request({ method: 'GET', path: `${this.base(accountId)}/cost-control`, auth: true });
    }
    createCostCenter(accountId, input) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/cost-centers`, body: input, auth: true });
    }
    updateCostCenter(accountId, costCenterId, input) {
        return this.client.request({ method: 'PATCH', path: `${this.base(accountId)}/cost-centers/${encodeURIComponent(costCenterId)}`, body: input, auth: true });
    }
    /** REPLACE the centers one desk member may book to (an empty list = an account-wide agent). */
    setMemberCostCenters(accountId, membershipId, costCenterIds, reasonCode) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/members/${encodeURIComponent(membershipId)}/cost-centers`, body: { costCenterIds, ...(reasonCode !== undefined ? { reasonCode } : {}) }, auth: true });
    }
    setSpendLimit(accountId, input) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/spend-limits`, body: input, auth: true });
    }
    clearSpendLimit(accountId, input) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/spend-limits/clear`, body: input, auth: true });
    }
    setBillingModel(accountId, billingModel, reasonCode) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/billing-model`, body: { billingModel, ...(reasonCode !== undefined ? { reasonCode } : {}) }, auth: true });
    }
    /** The categories the account sells in a market; `null` removes the scope (the account sells the market's whole set). */
    setCategories(accountId, marketId, categoryCodes, reasonCode) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/categories`, body: { marketId, categoryCodes, ...(reasonCode !== undefined ? { reasonCode } : {}) }, auth: true });
    }
    /** H1M (Q-131): PROPOSES a new zone and its fixed fare (202); another operator approves it (`decideQuickZoneProposal`). */
    createQuickZone(accountId, input) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/quick-zones`, body: input, auth: true });
    }
    /** PROPOSES a new immutable fare version (omitted fields carry over from the newest one); another operator approves it. */
    addQuickZoneVersion(accountId, zoneId, input) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/quick-zones/${encodeURIComponent(zoneId)}/versions`, body: input, auth: true });
    }
    /** H1M (Q-131): the checker approves or rejects a proposal (never the proposer's own). Approving creates the zone / the version. */
    decideQuickZoneProposal(proposalId, decision, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-quick-zone-proposals/${encodeURIComponent(proposalId)}/${decision}`, body: reasonCode !== undefined ? { reasonCode } : {}, auth: true });
    }
    setQuickZoneStatus(accountId, zoneId, status, reasonCode) {
        return this.client.request({ method: 'POST', path: `${this.base(accountId)}/quick-zones/${encodeURIComponent(zoneId)}/status`, body: { status, ...(reasonCode !== undefined ? { reasonCode } : {}) }, auth: true });
    }
}
//# sourceMappingURL=partner-cost-control.js.map